import { themeVars } from '@coverflex-tech/hypernova';
import { createVar, style } from '@vanilla-extract/css';

//@TODO: This is temporary
const lg = '(max-width: 1024px)';

const wrapper = style({
  position: 'relative',
  width: '100%',
});

const footer = style({
  position: 'fixed',
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  background: 'var(--color-dashboard-background)',
  '@media': {
    [lg]: {
      bottom: '6.4rem',
      background: themeVars.color.semantic.surface.accentSecondary10,
    },
  },
});

const contentWrapper = style({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginLeft: 'var(--sidebar-width)',
  borderTop: `0.1rem solid ${themeVars.color.semantic.border.neutral20}`,
  '@media': {
    [lg]: {
      marginLeft: '0',
    },
  },
});

const maxRightPadding = createVar();
const remainingFreeSpace = createVar();

const content = style({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  padding: '1.6rem var(--spacing-2xl)',
  maxWidth: 'var(--content-max-width)',
  paddingRight: `clamp(var(--spacing-2xl), ${maxRightPadding} - ${remainingFreeSpace}, ${maxRightPadding})`,
  vars: {
    [maxRightPadding]: 'calc(var(--spacing-2xl) * 2)',
    [remainingFreeSpace]:
      'calc((100vw - var(--sidebar-width) - var(--content-max-width) - var(--spacing-2xl)))',
  },
  '@media': {
    [lg]: {
      paddingRight: 'var(--spacing-lg)',
      paddingLeft: 'var(--spacing-lg)',
    },
  },
});

const spacer = style({
  display: 'block',
  width: '100%',
  minHeight: '9.2rem',
});

export const css = {
  wrapper,
  footer,
  contentWrapper,
  content,
  spacer,
};
